export const OCTOCAPTCHA_TIMEOUT = 30000
